/**
 * @documental
 * @export Item
 * @name
 * Menu.Item
 */
import { FC, ReactNode } from "react";

import { BaseProps } from "../../BaseProps";
import { ItemClickEventHandler } from "./ItemClickEventHandler";

/**
 * The `Item` component properties.
 */
export interface ItemProps extends BaseProps {
  /**
   * Indicates whether the item is disabled. If not specified defaults to `false`.
   */
  readonly disabled?: boolean;

  /**
   * The button tooltip.
   */
  readonly tooltip?: ReactNode;

  /**
   * The item children.
   */
  readonly children?: ReactNode;

  /**
   * Function to call when the item is clicked.
   */
  readonly onClick?: ItemClickEventHandler;

  /**
   * determines if the action is normal (blue) or high-impact (red)
   * takes precedence over the color prop
   */
  readonly type?: "normal" | "high-impact";
}

/**
 * A single item for the `Menu` component.
 */
export const Item: FC<ItemProps> = () => {
  return null;
};
